import { render, staticRenderFns } from "./SectionPaginationFooter.vue?vue&type=template&id=6c8e8dd8"
import script from "./SectionPaginationFooter.vue?vue&type=script&lang=js"
export * from "./SectionPaginationFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports